import { Skeleton, SkeletonLines } from "components/new-stuff/ui/Skeleton"
import CustomCard from "components/new-stuff/ui/CustomCard"
import TransactionsTemplate from "./TransactionsTemplate"

/**
 * The Earned Wage Access dashboard, drawn before the earnings wallet loads.
 *
 * The page has to wait for the wallet, because it decides between the
 * dashboard and the no-wallet screen. It used to wait behind a full-screen
 * spinner; this draws the dashboard's own layout instead, since that is where
 * an enrolled employee lands: the accrued-amount card over its stats in the
 * same five-column grid, the details card beside it, and recent transactions
 * in the real transactions table's skeleton.
 */
export const EwaDashboardSkeleton = () => (
  <div aria-busy="true">
    <div className="lg:h-[284px] flex flex-col lg:grid grid-cols-5 gap-4 mb-10">
      <div className="col-span-3 h-full flex flex-col">
        {/* Accrued amount: blue in the real page. */}
        <div className="h-[112px] bg-primary500 py-[27px] px-4 lg:px-[30px] flex flex-col justify-center gap-3">
          <Skeleton
            width="120px"
            className="opacity-40"
          />
          <Skeleton
            width="180px"
            height="20px"
            className="opacity-40"
          />
        </div>
        <div className="flex-grow bg-white py-[23px] px-4 lg:px-[62px] flex items-center gap-10">
          {[0, 1].map((i) => (
            <div
              key={i}
              className="flex flex-col gap-2"
            >
              <Skeleton
                width="110px"
                height="24px"
              />
              <Skeleton width="80px" />
            </div>
          ))}
          <Skeleton
            width="120px"
            height="40px"
            variant="block"
            className="ml-auto"
          />
        </div>
      </div>

      <div className="col-span-2 h-fit lg:h-full bg-white rounded-5px py-5 lg:pt-[41px] px-4 lg:px-5 flex flex-col gap-4">
        <Skeleton width="160px" />
        <div className="bg-[#EEF4FE] rounded px-4 lg:px-6 py-4 flex-grow">
          <SkeletonLines lines={3} />
        </div>
      </div>
    </div>

    <CustomCard title="Recent Transactions">
      <TransactionsTemplate
        data={[]}
        isLoading
      />
    </CustomCard>
  </div>
)

export default EwaDashboardSkeleton
